import { ErrorResponseTypeEnum } from 'modules/App/types';
import type { ResponseError } from 'modules/App/types';

export const isValidationError = ({ type }: ResponseError): boolean =>
  type === ErrorResponseTypeEnum.ValidationError;

export const getErrorDetails = ({
  displayMessage = '',
}: ResponseError): string => displayMessage;
